
import { reactive, nextTick, toRefs, onMounted, provide, computed,defineComponent } from "vue";
import { getLanguage } from "./utils/cookies";
import elementEnLocale from "element-plus/lib/locale/lang/en";
import elementZhLocale from "element-plus/lib/locale/lang/zh-cn";
import elementKoLocale from "element-plus/lib/locale/lang/ko";
import elementJaLocale from "element-plus/lib/locale/lang/ja";
import elementDeLocale from "element-plus/lib/locale/lang/de";
import elementFrLocale from "element-plus/lib/locale/lang/fr";
import elementPlLocale from "element-plus/lib/locale/lang/pl";
import elementNlLocale from "element-plus/lib/locale/lang/nl";
export default defineComponent ({
  setup() {
    const locale = computed(() => state.getlauge());
    const state = reactive({
      isRouterAlive: true,
      getlauge() {
        let lang = getLanguage();
        if (lang) {
          if (lang == "ko") {
            return elementKoLocale;
          } else if (lang == "en") {
            return elementEnLocale;
          } else if (lang == "ja") {
            return elementJaLocale;
          } else if (lang == "de") {
            return elementDeLocale;
          } else if (lang == "fr") {
            return elementFrLocale;
          } else if (lang == "pl") {
            return elementPlLocale;
          } else if (lang == "nl") {
            return elementNlLocale;
          } else {
            return elementZhLocale;
          }
        }
        const language = navigator.language.toLowerCase();
        console.log(language, "zou到这里");
        if (language == "ko") {
          return elementKoLocale;
        } else if (language == "en") {
          return elementEnLocale;
        } else if (language == "ja") {
          return elementJaLocale;
        } else if (language == "de") {
          return elementDeLocale;
        } else if (language == "fr") {
          return elementFrLocale;
        } else if (language == "pl") {
          return elementPlLocale;
        } else if (language == "nl") {
          return elementNlLocale;
        } else {
          return elementZhLocale;
        }
      },
      reload() {
        state.isRouterAlive = false;
        nextTick(() => (state.isRouterAlive = true));
      }
    });
    provide("reload", state.reload);
    onMounted(() => {
      // document.getElementsByTagName('body')[0].style.fontFamily = 'Arial,"PingFang SC","Hiragino Sans GB","Microsoft YaHei","WenQuanYi Micro Hei",sans-serif;'
      document
        .getElementsByTagName("body")[0]
        .setAttribute(
          "style",
          'font-family:Arial,"PingFang SC","Hiragino Sans GB","Microsoft YaHei","WenQuanYi Micro Hei",sans-serif;'
        );
      console.log(document.getElementsByTagName('body')[0].style.fontFamily,'查看字体')
    });
    return {
      ...toRefs(state),
      locale
    };
  }
});
// window.onload = function() {
//   document.body.onkeydown = function(event) {
//     if (event.keyCode == 13 || event.keyCode == 32) {
//       return false;
//     }
//   };
// };
